import React, { Component } from "react"
import axios from "axios"
import theme from "../styles/theme"
import styled from "@emotion/styled"

const Outer = styled.div`
  padding: 0 32px;
`
const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: auto;
  grid-gap: 32px;
  align-items: center;
  max-width: ${theme.maxwidth.default};
  margin-left: auto;
  margin-right: auto;
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`
const Container2 = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`
const Card = styled.div`
  box-shadow: ${theme.shadow.long};
  padding: 32px;
  height: 100%;
  display: flex;
  flex-direction: column;
`
const Ticks = styled.ul`
  padding: 0;
  padding: 0;
  margin: 0;
  font-size: 1.2rem;
`
const Tick = styled.li`
  list-style: none;
  line-height: 1.5;
  position: relative;
  padding: 8px 0 8px 32px;
  &:before {
    content: "";
    position: absolute;
    width: 16px;
    height: 8px;
    border-bottom: 2px solid ${theme.color.accent};
    border-left: 2px solid ${theme.color.accent};
    transform: rotate(-45deg);
    left: 0px;
    top: 16px;
  }
`
const Price = styled.h2`
  margin: 0;
`
const PriceContainer = styled.div`
  margin: 32px -32px;
  padding: 16px 32px;
  background-color: #f7f9fc;
`
const Content = styled.div`
  padding: 0 0 32px 0;
  width: 800px;
  margin: 0 auto;
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-column: span 1;
  }

  @media (max-width: 864px) {
    width: 100%;
  }
`
const Footer = styled.div`
  grid-column: span 4;
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-column: span 1;
  }
`
const Plan = styled.h3``
const Billing = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: ${theme.color.shade.battleship};
`
const Button = styled.a`
  border: none;
  padding: 8px 16px;
  background: ${theme.color.accent};
  color: ${theme.color.ink};
  border-radius: ${theme.border.default};
  width: 100%;
  display: block;
  text-align: center;
  margin-top: auto;
`

export const DiscountTextBox = styled.div`
  width: 229px;
  height: 24px;
  border-radius: 4px;
  background-color: #00c5cc;
  color: white;
  margin: 0 auto;
  font-size: 14px;
`

export default class MediaFeature extends Component {
  constructor(props) {
    super(props)
    this.state = {
      countryName: "",
      isYearly: true,
      packagePrices: {
        package1: {
          monthly: 249.0,
          yearly: 199.0,
        },
        package2: {
          monthly: 499.0,
          yearly: 399.0,
        },
        package3: {
          monthly: 1199.0,
          yearly: 999.0,
        },
        package4: {
          monthly: 9000,
          yearly: 7500,
        },
      },
    }
  }

  render() {
    return (
      <Outer>
        <Container2 style={{ textAlign: "center" }}>
          <Content>{this.props.content}</Content>
        </Container2>
        <Container>
          <Card>
            <Plan>Start up</Plan>
            <br />
            <p>
              Best for startups primarily doing founder sales, many times Seed
              funded or even pre-revenue.
            </p>
            <PriceContainer>
              <Price>
                {this.props.currency}
                {this.state.isYearly
                  ? this.state.packagePrices.package1.yearly
                  : this.state.packagePrices.package1.monthly}
                .00 <span style={{ fontSize: 18 }}>per month</span>
              </Price>
              <Billing>2 licenses</Billing>
            </PriceContainer>
            <p>
              <strong>Enabling you to…</strong>
            </p>
            <ul>
              <li>Set & Monitor Business Goals & Objectives</li>
              <li>Define, Document & Organize your Sales Cycle</li>
              <li>(Dis)Qualify Prospects Efficiently</li>
              <li>
                Customer Success representative available for onboarding Q&A
              </li>
            </ul>
            <Button href="http://stack-global.herokuapp.com/app">
              Start with Start up
            </Button>
          </Card>
          <Card>
            <Plan>Growth</Plan>
            <p>
              Great for startups that have initial sales hires with the
              intention for future hires, usually late seed or early Series A
              funded
            </p>
            <PriceContainer>
              <Price>
                {this.props.currency}
                {this.state.isYearly
                  ? this.state.packagePrices.package2.yearly
                  : this.state.packagePrices.package2.monthly}
                .00 <span style={{ fontSize: 18 }}>per month</span>
              </Price>
              <Billing>8 licenses</Billing>
            </PriceContainer>
            <p>
              <strong>Start up, plus…</strong>
            </p>
            <ul>
              <li>Target & Spend Time with the Right Prospects</li>
              <li>Scenario Play Revenues</li>
              <li>Scenario Play Number of Clients and Acquisition Channels</li>
              <li>Document & Align Your Product Roadmap with Your Goals</li>
              <li>Access to monthly, sales best-practice webinars</li>
            </ul>
            <Button href="http://stack-global.herokuapp.com/app">
              Start with Growth
            </Button>
          </Card>
          <Card>
            <Plan>Scaling</Plan>
            <p>
              Perfect for companies with sales and business development teams of
              10+, commonly late Series A or Series B-C funded
            </p>
            <PriceContainer>
              <Price>
                {this.props.currency}
                {this.state.isYearly
                  ? this.state.packagePrices.package3.yearly
                  : this.state.packagePrices.package3.monthly}
                .00 <span style={{ fontSize: 18 }}>per month</span>
              </Price>
              <Billing>20 licenses</Billing>
            </PriceContainer>
            <p>
              <strong>Growth, plus…</strong>
            </p>
            <ul>
              <li>
                Quantify your Sales Funnel and Map Key Activities Against Stages
              </li>
              <li>
                Ensure The Right People Are Focused on the Right Activities
              </li>
              <li>Access to monthly, sales best-practice webinars</li>
            </ul>
            <Button href="http://stack-global.herokuapp.com/app">
              Start with Scaling
            </Button>
          </Card>
          <Card>
            <Plan>Unicorn</Plan>
            <p>For those companies who have 'taken the leap'</p>
            <br />
            <br />
            <br />
            <PriceContainer>
              <Price>
                {this.props.currency}
                {this.state.isYearly
                  ? this.state.packagePrices.package4.yearly
                  : this.state.packagePrices.package4.monthly}
                .00 <span style={{ fontSize: 18 }}>per month</span>
              </Price>
              <Billing>Unlimited</Billing>
            </PriceContainer>
            <p>
              <strong>Scaling, plus…</strong>
            </p>
            <ul>
              <li>
                Have a Dedicated Stack Associate Be an Ongoing Resource for your
                firm.
              </li>
              <li>Multi-level persmissioning</li>
              <li>Sales dashboard & tracking</li>
            </ul>
            <Button href="http://stack-global.herokuapp.com/app">
              Start with Unicorn
            </Button>
          </Card>
          <Footer style={{ textAlign: "center" }}>
            {this.props.footer}

            {this.state.isYearly && (
              <div
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() =>
                  this.setState({ isYearly: !this.state.isYearly })
                }
              >
                Click here to see prices billed monthly
              </div>
            )}
            {!this.state.isYearly && (
              <div
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() =>
                  this.setState({ isYearly: !this.state.isYearly })
                }
              >
                Click here to see prices billed annually
              </div>
            )}
            <br />
            <DiscountTextBox>20% discount when billed annually</DiscountTextBox>
          </Footer>
        </Container>
      </Outer>
    )
  }
}
